var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { IdentitySerializer, IgnoreMergeFunction } from '../../helpers/default-merge-functions';
var PropertyBuilderImpl = /** @class */ (function () {
    function PropertyBuilderImpl(name, selector, options) {
        this.name = name;
        this.selector = selector;
        this.options = options;
    }
    PropertyBuilderImpl.prototype.build = function () {
        return __assign(__assign({}, this.options), { defaultValue: this.options.defaultValue, deserializer: this.options.deserializer, initialValue: this.options.initialValue, name: this.name, normaliseInput: this.options.normaliseInput, selector: this.selector, serializer: this.options.serializer || IdentitySerializer, type: 'simple' });
    };
    PropertyBuilderImpl.prototype.defaultValue = function (defaultValue) {
        return this.with({
            defaultValue: defaultValue,
        });
    };
    PropertyBuilderImpl.prototype.ignore = function () {
        return this.with({
            serializer: IgnoreMergeFunction,
        });
    };
    PropertyBuilderImpl.prototype.initializeWith = function (initialValue) {
        return this.with({
            initialValue: initialValue,
        });
    };
    PropertyBuilderImpl.prototype.serializeWith = function (mergeFunction, predicate) {
        if (predicate === void 0) { predicate = true; }
        return this.with({
            serializer: mergeFunction,
        }, predicate);
    };
    PropertyBuilderImpl.prototype.deserializeWith = function (parseFunction, predicate) {
        if (predicate === void 0) { predicate = true; }
        return this.with({
            deserializer: parseFunction,
        }, predicate);
    };
    PropertyBuilderImpl.prototype.with = function (newOptions, predicate) {
        if (predicate === void 0) { predicate = true; }
        var maybeNewBuilder = this;
        if (predicate) {
            maybeNewBuilder = new PropertyBuilderImpl(this.name, this.selector, __assign(__assign({}, this.options), newOptions));
        }
        return maybeNewBuilder;
    };
    return PropertyBuilderImpl;
}());
export { PropertyBuilderImpl };
//# sourceMappingURL=property-builder-impl.js.map